import CompanyInfo from './company_info.vue';

export default CompanyInfo;
